import React, { useMemo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import apiService from '@services/apiService';

const extensionDict = {
  doc: 'word',
  docx: 'word',
  pdf: 'pdf',
  rtf: 'alt',
  txt: 'alt',
  xls: 'spreadsheet',
  xlsx: 'spreadsheet',
  gif: 'image',
  jpg: 'image',
  jpeg: 'image',
  png: 'image',
  tiff: 'image',
  mov: 'video',
  mp4: 'video',
  mpeg: 'video',
  wmv: 'video',
  quicktime: 'video',
};

const SupplementLink = ({ path }) => {
  const [fileBlob, setFileBlob] = useState(null);
  const [blobURL, setBlobURL] = useState('');
  const [blobSize, setBlobSize] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const currentIcon = useMemo(() => {
    if (path) {
      const extension = path.substring(path.lastIndexOf('.') + 1);
      return `far fa-file-${extensionDict[extension]}`;
    }
    return null;
  }, [path]);

  const retrieveFile = async awsUrl => {
    try {
      const response = await apiService.Photos.getSingleImage(awsUrl);
      return response;
    } catch (er) {
      // eslint-disable-next-line no-console
      console.error('Error: SupplementLink retrieveFile:', er);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (fileBlob) {
      const megabytes = Math.round((fileBlob.size * 0.000001 + Number.EPSILON) * 100) / 100;
      setBlobSize(megabytes);
      setBlobURL(URL.createObjectURL(fileBlob));
    }
  }, [fileBlob]);

  useEffect(async () => {
    try {
      if (path) {
        setIsLoading(true);
        const fileResp = await retrieveFile(path);
        setFileBlob(fileResp);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Error: SupplementLink retrieveFile', err);
    }
  }, [path]);

  return (
    <div className="form-group">
      <div className="row justify-content-start align-items-center">
        <div className="col-1" />
        <div className="col text-center">
          <Button
            name="btnDownloadSupplement"
            variant="primary"
            href={blobURL}
            disabled={isLoading}
            size="sm"
            download
          >
            <i className="far fa-download mr-2" />
            Download
            {' ('}
            <i className={currentIcon} />
            {isLoading ? <i className="fas fa-circle-notch fa-fwd fa-spin" /> : ` , ${blobSize} MB`}
            {') '}
          </Button>
        </div>
      </div>
    </div>
  );
};

SupplementLink.propTypes = {
  path: PropTypes.string,
};

export default SupplementLink;
